module.exports = __webpack_public_path__ + "img/img_14.db6c179f.svg";